// Convert EffectLogLevel to enum
export enum EffectLogLevel {
  TRACE = 'trace',
  DEBUG = 'debug',
  INFO = 'info',
  WARNING = 'warning',
  ERROR = 'error',
  FATAL = 'fatal',
}

export type ErrorType = {
  response?: {
    data?: {
      statusCode?: number;
      message?: string;
    };
  };
  message?: string;
  statusCode?: number;
  logLevel?: EffectLogLevel;
};
